module.exports = ClipboardJS;